import axios, { AxiosResponse } from 'axios';

import { apiUrl } from '@/config/api';

import { ApiLogin, ApiAccount } from './types/auth';

const login = (token: string): Promise<AxiosResponse<ApiLogin>> => {
    const config = {
        headers: {
            Authorization: `Basic ${token}`,
        },
    };
    return axios.post(`${apiUrl}/system/authentication/gettoken`, {}, config);
};

const redeem = (token: string): Promise<AxiosResponse<ApiLogin>> => {
    return axios.get(`${apiUrl}/system/authentication/redeemtoken?tokenKey=${token}`);
};

const account = (token: string): Promise<AxiosResponse<ApiAccount>> => {
    return axios.get(`${apiUrl}/trk/common/user/info`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const updateAccount = (token: string, userData: ApiAccount): Promise<AxiosResponse<ApiAccount>> => {
    return axios.post(`${apiUrl}/trk/common/user/info`, userData, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

/* const logout = (token) => {
    axios({
        method: 'post',
        url: `${window.__env.apiUrl}/api/logout`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
} */

/* const verify = (token) => {
    return axios({
        method: 'post',
        url: `${window.__env.apiUrl}/api/verify`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
} */

export default {
    login,
    redeem,
    account,
    updateAccount,
    // logout,
    // verify,
};
